import React from 'react';
import { Link } from 'react-router-dom';
import './components.css';

const Workout = (props) => {
  return (
    <Link className="mb-5 no-underline block" to={`/workouts/${props.id}`} tabIndex={1}>
      <div className="workout-card rounded-2xl p-4 sm:p-5 hover:shadow-elev transition-all duration-200 animate-slideUp">
        <div className="flex flex-col gap-2 prose-2025">
          <div className="flex items-center gap-2 text-zinc-700 dark:text-zinc-300">
            <i className="fas fa-dumbbell"></i>
            <h3>{props.title}</h3>
          </div>
          <div className="flex items-center gap-2 muted-2025">
            <i className="far fa-calendar-alt"></i>
            <p>{props.time}</p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Workout;